<template>
    <div class="printOrderListBox">
        <el-tabs
            v-model="modelStatus"
            class="orderListTabs"
            @tab-click="getModelOrderList"
        >
            <el-tab-pane
                v-for="item in tabList"
                :key="item.id"
                :label="item.name"
                :name="item.id"
            >
            </el-tab-pane>
        </el-tabs>
        <div>
            <div class="orderSearchBox">
                <div class="timeSearch">
                    <span style="color: #b2b2b2;">创建时间</span>
                    <el-date-picker
                        v-model="createDate"
                        value-format="yyyy-MM-dd"
                        type="daterange"
                        range-separator="—"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期">
                    </el-date-picker>
                </div>
                <!-- <div class="timeSearch">
                    <span style="color: #b2b2b2;">区间筛选</span>
                     <el-date-picker
                        v-model="createDateValue"
                        type="daterange"
                         value-format="yyyy-MM-dd"
                        range-separator="—"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        >
                    </el-date-picker>
                </div> -->
                <el-input v-model="modelName" placeholder="模型名称"></el-input>
                <!--<el-input v-model="merchantNameValue" placeholder="作者名称"></el-input>-->
                <el-input v-model="orderNo" placeholder="订单编号"></el-input>
                <!--          <el-select v-model="modelStatus" placeholder="订单状态">
                                      <el-option label="全部" value=""> </el-option>
                                      <el-option label="待付款" value="UN_PAY"> </el-option>
                                      <el-option label="待评价" value="UN_APPRAISE"> </el-option>
                                      <el-option label="完成" value="FINISHED"> </el-option>
                                  </el-select>
                <el-select v-model="evaluateStatusValue" placeholder="评价状态">
                    <el-option label="好评" value="好评"></el-option>
                    <el-option label="中评" value="中评"></el-option>
                    <el-option label="差评" value="差评"></el-option>
                </el-select>-->
                <el-button class="searchBtn" @click="getModelOrderList">搜索</el-button>
                <el-button type="text" class="resetBtn" @click="reset">
                    <i class="iconfont icon-qingchushujuku"></i>
                    <span>清除条件</span>
                </el-button>
            </div>
            <div class="orderListTable">
                <ul class="tableHeader">
                    <li class="name">模型名称</li>
                    <li class="payment">一级分类</li>
                    <li class="payment">二级分类</li>
                    <li class="price">模型描述</li>
                    <!--<li class="arguments">模型参数</li>-->
                    <li class="payment">实付款</li>
                    <li class="status">订单状态</li>
                    <li class="status">开票状态</li>
                    <li class="operation">操作</li>
                </ul>
                <ul class="tableBody" v-if="modelOrderList.length != 0" v-loading="loading">
                    <li
                        class="bodyItem"
                        v-for="(items, index) in modelOrderList"
                        :key="index"
                    >
                        <div class="itemTop">
                             <div>订单编号：{{ items.orderBase.orderNo }}</div>
                            <div>创建时间：{{ items.orderBase.createDate }}</div>
                            <div class="merchantInfo">
                                <img :src="items.userImg" alt="" width="80px"/>
                                <span>{{ items.modelCreatorName }}</span>
                            </div>
                        </div>
                        <div class="itemBottom">
                            <div class="name">
                                <div class="orderInfo">
                                    <div class="orderInfoImg">
                                        <img :src="items.modelImg" alt=""/>
                                        <button @click="handPreview(items)">预览</button>
                                    </div>
                                    <div class="infoContent">
                                        <div class="infoName">{{ items.modelName }}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="payment">
                                {{ items.typeFirstName }}
                            </div>
                            <div class="payment">
                                {{ items.typeSecondName }}
                            </div>
                            <div class="price">
                                {{ items.modelRemark }}
                            </div>
                            <!--<div class="arguments">
                                            <div class="argumentsName">
                                              表面积：{{ items.argumentsName }}
                                            </div>
                                            <div class="argumentsName">
                                              体&nbsp;&nbsp;积：{{ items.argumentsName2 }}
                                            </div>
                                            <div class="argumentsName">
                                              尺&nbsp;&nbsp;存：{{ items.argumentsName3 }}
                                            </div>
                                          </div>-->
                            <div class="payment">
                                <h3>¥{{ items.price == null ? 0 : items.price }}</h3>
                            </div>
                            <div class="status">
                                <div class="statusName">{{ items.modelStatusCn }}</div>
                                <el-button
                                    type="text"
                                    class="operationBtn"
                                    @click="modelOrderDetail(items.uuid)"
                                >订单详情
                                </el-button
                                >
                            </div>
                            <div class="status">
                                <div>{{ items.issueInvoiceType==null?"未开票":items.issueInvoiceType=="EXAMINE"?'开票中':items.issueInvoiceType=='PASS'?'已开票':'已拒绝' }}</div>
                            </div>
                            <div class="operation">
                                <el-button type="text" class="operationBtnMoney" v-if="items.modelStatus === 'UN_PAY'" @click="submitPay(items)">付款</el-button>
                                <el-button type="text" class="operationBtnMoney" v-if="items.modelStatus === 'UN_PAY'" @click="cancelOrder(items)">取消订单</el-button>
                                <el-button v-if="items.modelStatus !== 'UN_PAY' && items.modelStatus !== 'CANCEL'"
                                    :loading="items.modelDownLoading"
                                    type="text"
                                    class="operationBtnMoney"
                                    @click="handleBatchDownload(items.uuid,index)"
                                >下载模型
                                </el-button>
                                <el-button v-if="items.modelStatus !== 'UN_PAY' && items.modelStatus !== 'CANCEL'"
                                           type="text"
                                           class="operationBtnMoney"
                                           @click="handleToPrint(items)"
                                >去打印
                                </el-button>
                                <el-button
                                    type="text"
                                    class="operationBtnMoney"
                                    v-if="items.modelStatus !== 'UN_PAY'
                                        && items.issueInvoiceType === null"
                                    @click="openInvoice(items)"
                                >申请开票</el-button>
                                <el-button type="text" class="operationBtnMoney" v-if="items.modelStatus=='UN_APPRAISE'"
                                           @click="toEvaluate(items)"
                                >评价
                                </el-button
                                >

                                <el-button type="text" class="operationBtnMoney"
                                           @click="complain(items.orderBase.uuid,items.modelCreatorUuid,items.modelCreatorName)"
                                           v-if="
                    items.modelStatus == 'UN_SEND' ||
                    items.modelStatus == 'UN_RECEIVE' ||
                    items.modelStatus == 'UN_APPRAISE' ||
                    items.modelStatus == 'AFTER_SALES' ||
                    items.modelStatus == 'FINISHED'

                  "
                                >投诉
                                </el-button
                                >

                                <!--<el-button type="text" class="operationBtnMoney"
                                           @click="AfterSales(items.orderBase.uuid,items.modelCreatorUuid,items.modelCreatorName)"
                                           v-if="
                    items.modelStatus == 'UN_CONFIRM' ||
                    items.modelStatus == 'UN_PAY' ||
                    items.modelStatus == 'UN_CANCEL'
                  "
                                >申请售后
                                </el-button
                                >-->
<!--                                <el-button type="text" class="operationBtn"
                                           @click="AfterSales(items.orderBase.uuid,items.modelCreatorUuid,items.modelCreatorName)">
                                    申请售后
                                </el-button>-->
                            </div>
                        </div>
                    </li>
                </ul>
                <!-- <div class="orderNomesaage" v-loading="loading" v-else >暂无数据</div> -->
                <div class="orderNomesaage" v-loading="loading" v-else >
                    <img src="../../../assets/暂无订单.jpg" alt="" style="width:200px">
                </div>
            </div>
        </div>
        <el-pagination
            v-if="modelOrderList.length != 0"
            background
            @current-change="handleCurrentChange"
            @prev-click="handleCurrentChange"
            @next-click="handleCurrentChange"
            layout="total,prev, pager, next,jumper"
            :page-size="pageSize"
            :total="total"
            class="pagination"
        >
        </el-pagination>

        <!--评价弹出框-->
        <el-dialog title="评价" :visible.sync="evaluateDialogVisible" width="500px">
            <div class="evaluateDialogBox">
                <div class="evaluateItem">
                    <div class="name">评价等级</div>
                    <div class="content">
                        <div class="rateItem">
                            <div class="name">描述相符</div>
                            <el-rate
                                v-model="evaluateForm.descriptionPoint"
                                show-score
                                text-color="#ff9900"
                            >
                            </el-rate>
                        </div>
                        <div class="rateItem">
                            <div class="name">服务态度</div>
                            <el-rate
                                v-model="evaluateForm.servicePoint"
                                show-score
                                text-color="#ff9900"
                            >
                            </el-rate>
                        </div>
                        <div class="rateItem">
                            <div class="name">专业程度</div>
                            <el-rate
                                v-model="evaluateForm.transportPoint"
                                show-score
                                text-color="#ff9900"
                            >
                            </el-rate>
                        </div>
                    </div>
                </div>
                <div class="evaluateItem">
                    <div class="name">评价标签</div>
                    <div class="content">
                        <el-checkbox-group
                            v-model="evaluateForm.evaluationTagList"
                            class="evaluateTag"
                        >
                            <el-checkbox-button
                                v-for="tag in tagList"
                                :label="tag"
                                :key="tag.tagUuid"
                            >{{ tag.tagName }}
                            </el-checkbox-button
                            >
                        </el-checkbox-group>
                    </div>
                </div>
                <div class="evaluateItem">
                    <div class="name">评价内容</div>
                    <div class="content">
                        <el-input
                            type="textarea"
                            :autosize="{ minRows: 6 }"
                            placeholder="请输入内容"
                            v-model="evaluateForm.evaluationContent"
                        >
                        </el-input>
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
        <el-button @click="evaluateDialogVisible = false">取 消</el-button>
        <el-button type="primary" :disabled="stepLoading" @click="evaluateSubmit">确 定</el-button>
      </span>
        </el-dialog>
        <!-- 3d预览 -->
        <three-d
            ref="threeBox"
            :innerVisible="innerVisible"
            :fileListNew="fileListNew"
            @closeDlog="closeDlog"
        ></three-d>

        <!-- 申请开票 -->
        <issue-invoice-dialog ref="invoiceDialogRef"></issue-invoice-dialog>

        <!-- 投诉弹窗 -->
        <complaints-dialog
            ref="dialogRef"
        ></complaints-dialog>

        <!-- 申请售后 -->
        <after-sales-dialog
            ref="afterSalesDialog"
        ></after-sales-dialog>

        <!-- 购买的弹窗 -->
        <PayModelDialog ref="payModelRef" @refreshData="getModelOrderList"/>

        <!-- 取消订单 -->
        <el-dialog
            title="取消订单"
            :visible.sync="cancelDialogVisible"
            :close-on-click-modal="false"
            width="1000px">
            <div class="logisticsDialog">
                <el-form ref="logisticsForm" :rules="cancelRules" class="demo-ruleForm">
                    <el-form-item class="addressList">
                        <el-select v-model="cancelUuid" placeholder="取消原因">
                            <el-option v-for="(item,index) in cancelList" :key="index"
                                       :label="item.name"
                                       :value="item.uuid">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item class="submitButtonGroup">
                        <el-button type="primary" @click="cancelSubmit">确定</el-button>
                        <el-button @click="cancelDialogVisible = false">取消</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import {getModelOrderList, getModelDetail, getDictionaryItem, saveEvaluation, editOrder,downloadFile} from "../../../utils/interface";
import {downLoad} from "../../../utils/downLoadModel";
import threeD from "../../../components/threeD/index"
import complaintsDialog from './complaintsDialog'
import issueInvoiceDialog from "./issueInvoiceDialog"
import afterSalesDialog from "./afterSalesDialog";
import PayModelDialog from './payModelDialog';
export default {
    name: "printOrderList",
    data() {
        return {
            stepLoading : false,
            loading: true,
            order: {},
            modelStatus: "",
            tabList: [
                {
                    id: "",
                    name: "全部",
                },
                {
                    id: "UN_PAY",
                    name: "待付款",
                },
                {
                    id: "UN_APPRAISE",
                    name: "待评价",
                },
                {
                    id: "FINISHED",
                    name: "完成",
                },
            ],
            createDate: null,
            modelName: "",
            merchantNameValue: "",
            orderNo: "",
            evaluateStatusValue: "",
            postSalesServiceValue: "",
            modelOrderList: [],
            pageNo: 1,
            total: 100,
            pageSize: 5,
            evaluateDialogVisible: false,
            evaluateForm: {
                descriptionPoint: 0,
                servicePoint: 0,
                transportPoint: 0,
                evaluationTagList: [],
                evaluationContent: "",
            },
            tagList: [
            ],
            innerVisible: false,
            fileListNew: [],
            // 取消订单
            cancelDialogVisible:false,
            cancelList:[],
            cancelUuid:"",
            cancelRules: {
                cancelUuid:[
                    {required: true, message: '请选择取消原因', trigger: 'change'}
                ]
            },
            modelOrderUuid:"",
        };
    },
    components: {
        threeD,
        complaintsDialog,
        issueInvoiceDialog,
        afterSalesDialog,
        PayModelDialog
    },
    created() {
        this.init();
    },
    methods: {
        // 取消
        cancelOrder(item){
            getDictionaryItem({groupCode:"model_cancel_reason"}).then((res)=>{
                this.cancelList = res;
                this.modelOrderUuid = item.uuid;
                this.orderBaseUuid = item.orderBase.uuid;
                this.cancelDialogVisible = true;
            });
        },
        cancelSubmit(){
            if(this.cancelUuid==""){
                this.$message.error('请选择取消原因！');
                return false;
            }
            editOrder({uuid:this.modelOrderUuid, modelStatus:"CANCEL",cancelOrderUuid:this.cancelUuid}).then((res)=>{
                if(res.success){
                    this.$message.success('订单取消成功！');
                    this.cancelUuid = "";
                    this.cancelDialogVisible = false;
                    this.getModelOrderList();
                }
            });
        },
        // 支付
        submitPay(item){
            this.$refs.payModelRef.init()
            window.open(this.$url.payUrl + item.orderBase.orderNo, "_blank");
        },
        // 获取字典值
        getDictionaryItem() {
            getDictionaryItem({groupCode: "model_evaluation_tag"}).then((res) => {
                this.tagList = [];
                res.forEach((item, index) => {
                    this.tagList.push({tagName: item.name, tagUuid: item.code, tagGroupId: item.groupUuid});
                });
            });
        },
        init() {
            this.reset();
            this.pageNo = 1;
            this.getModelOrderList();
            this.getDictionaryItem();
        },
        searchInfo(){
            this.init();
        },
        // 检索重置
        reset() {
            this.modelName = "";
            this.orderNo = "";
            // this.modelStatus = ''
            this.createDate = null;
            // this.modelOrderList = [];
            // this.order = {};
        },
        getModelOrderList() {
            this.loading = true
            let params = {
                modelName: this.modelName,
                orderNo: this.orderNo,
                modelStatus: this.modelStatus == 0 ? "" : this.modelStatus,
                createDate:
                    this.createDate == null
                        ? null
                        : this.createDate.join(" - "),
                current: this.pageNo,
                pageSize: this.pageSize,
                isBuy: true,
            };
            getModelOrderList(params).then((res) => {
                res.list.forEach(items=>{
                    items.modelDownLoading = false
                })
                this.modelOrderList = res.list;
                this.total = res.total;
                // console.log(this.modelOrderList);
                this.loading = false
            });
        },
        handleSizeChange(val) {
            this.pageSize = val;
        },
        handleCurrentChange(val) {
            this.pageNo = val;
            this.getModelOrderList();
        },
        handleBatchDownload(val,index) {
            this.modelOrderList[index].modelDownLoading = true
            downloadFile(val).then((res) => {
                if(res.headers["error"]){
                    this.$message.error(decodeURI(res.headers["error"]))
                }else if(res && res.data){
                    let zip = window.URL.createObjectURL(new Blob([res.data],{type: "application/zip"}));
                    let fileName = res.headers["content-disposition"].split(";")[1].split("filename=")[1];
                    let s= /\"/g
                    fileName = fileName.replace(s,'')
                    fileName = decodeURI(fileName)  //对文件名decodeURI解码，解决中文名乱码问题
                    const link = document.createElement('a');
                    link.href = zip;
                    link.setAttribute('download', fileName);
                    document.body.appendChild(link);
                    link.click()
                    const a = URL.revokeObjectURL(link.href); // 释放
                    this.$message.success("文件打包成功")
                    this.modelOrderList[index].modelDownLoading = false
                }
            });
            /*getModelDetail({uuid: val}).then( async (res) => {
                let data = [];
                res.urlList.map((file) => {
                    if (file.fileType === "FILE") {
                        let obj = {};
                        obj.name = file.name;
                        obj.url = file.modelUrl;
                        data.push(obj);
                    }
                });
                this.modelOrderList[index].modelDownLoading = true
                try {
                    let modelMess = await downLoad(data, res.modelName + ".zip")
                    if (modelMess == true) {
                        this.$message.success("文件打包成功")
                    } else {
                        this.$message.error("文件打包失败")
                    }
                } catch (error) {
                    this.$message.error("文件打包错误,请联系管理员！")
                }
                this.modelOrderList[index].modelDownLoading = false

            });*/
                // downLoad(data, res.modelName + ".zip");
        },
        // 点击去打印
        handleToPrint(item){
            window.open(this.$url.threeWeb+"/printPlaceAnOrder?modelUuid="+item.modelUuid,'_target');
        },
        // 点击打开评价弹出框
        toEvaluate(order) {
            this.order = order;
            console.log(order);
            this.evaluateForm = {
                descriptionPoint: 0,
                servicePoint: 0,
                transportPoint: 0,
                evaluationTagList: [],
                evaluationContent: "",
            };
            this.evaluateDialogVisible = true;
        },
        // 评价提交
        evaluateSubmit() {
            this.stepLoading = true;
            if (
                this.evaluateForm.descriptionPoint &&
                this.evaluateForm.servicePoint &&
                this.evaluateForm.transportPoint
            ) {
                this.evaluateForm.orderNo = this.order.orderBase.orderNo;
                this.evaluateForm.orderUuid = this.order.uuid;
                this.evaluateForm.orderType = 'MODEL';
                this.evaluateForm.evaluationType = 'NORMAL';
                this.evaluateForm.sellerName = this.order.modelCreatorName;
                this.evaluateForm.sellerUuid = this.order.modelCreatorUuid;
                this.evaluateForm.orderName = this.modelName;
                this.evaluateForm.orderAmount = this.order.orderBase.totalPrice;

          saveEvaluation(this.evaluateForm).then((response) => {
              if (response.success) {
                  this.evaluateDialogVisible = false;
                  this.getModelOrderList();
                  this.$message({
                      type: "success",
                      message: "评价成功",
                  });
              } else {
                  this.$message({
                      type: "error",
                      message: response.message,
                  });
              }
          });
      } else {
        this.$message.warning("请选择评价等级");
      }
            setTimeout(() => {
                this.stepLoading = false;
            }, 1000);
    },
    // 模型详情
    modelOrderDetail(id) {
      this.$router.push({
        path: "/modelOrderDetail",
        query: {
          uuid: id,
        },
      });
    },
    // 预览模型
    handPreview(info) {
      this.$refs.threeBox.threeAnimal(info);
      this.innerVisible = !this.innerVisible;
    },
    closeDlog(index) {
      this.innerVisible = index;
    },
    // 申请开票
    openInvoice(item){

        let params = {uuid:item.issueInvoiceUuid,
            orderUuid:item.orderBaseUuid,
            orderNo:item.orderBase.orderNo,
            orderName:item.modelName,
            orderImg:item.modelImg,
            orderType:'MODEL',
            issueUser:item.modelCreatorUuid,
            invoiceMoney:item.orderBase.totalPrice,
        }
        this.$refs.invoiceDialogRef.init(params);
    },
    complain(orderBaseUuid, targetUserUuid, enterPriseName) {
        this.$refs.dialogRef.init(orderBaseUuid, targetUserUuid, enterPriseName);
    },
    // 申请售后
    AfterSales(orderBaseUuid, targetUserUuid, enterPriseName){
        this.$refs.afterSalesDialog.init(orderBaseUuid, targetUserUuid, enterPriseName)
    },
  },
};
</script>

<style scoped lang="less">
.printOrderListBox {
    padding: 94px 20px 20px;

    .orderListTabs {
        position: absolute;
        left: 0;
        top: 0;
        z-index: 999;
        background: #fff;
        width: 100%;
        padding: 20px;
    }

    /deep/ .el-tabs__item {
        padding: 0 25px !important;
        text-align: center;

        &:hover {
            color: #3686d7;
        }

        &:after {
            content: "";
            position: absolute;
            right: 0;
            bottom: 12px;
            width: 1px;
            height: 15px;
            background-color: #e4e7ed;
            z-index: 1;
        }

        &:last-child:after {
            content: "";
            width: 0;
            height: 0;
        }
    }

    /deep/ .el-tabs__active-bar {
        height: 3px;
        background-color: #3686d7;
    }

    /deep/ .el-tabs__item.is-active {
        color: #3686d7;
    }

    /deep/ .el-tabs__nav-wrap::after {
        height: 1px;
    }

    .orderSearchBox {
        display: flex;
        flex-wrap: wrap;
.timeSearch{
                background-color:#f2f4f7;
                height: 35px;
                display: flex;
                align-items: center;
                margin-bottom: 22px;
                margin-right: 30px;
                border-radius: 8px;
                span{
                    font-size: 12px;
                    color: #c0c4cc!important;
                    font-weight: normal;
                    padding-left: 15px;
                    margin-right: 5px;
                }
                // /deep/ .el-range-input{
                //         background-color: #f2f4f7;
                //             &:hover, &:focus {
                //             background-color: #fff;
                //             // border: 1px solid #108EE9;
                //         }
                // }
                /deep/input::-webkit-input-placeholder {
                    color: #c0c4cc;
                    font-size: 12px;
                }
              /deep/.el-range-input:hover{
                  background-color: #fff!important;
              }
              /deep/ .el-date-editor .el-range-separator{
                  line-height: 25px;
                  color: #c0c4cc;
              }
             /deep/ .el-date-editor .el-range__close-icon{
                 line-height: 28px;
             }
              /deep/ .el-input__inner:hover  .el-range-input, /deep/ .el-input__inner:focus  .el-range-input{
                  background-color: white;
              }
                /deep/ .el-input__inner {
                width: 225px;
                height: 35px;
                min-height: 35px;
                font-size: 12px;
                color: #999999;
                background-color: #f2f4f7;
                border: 1px solid #f2f4f7;
                border-radius: 5px;
                .el-range-input{
                    background-color:#f2f4f7 ;
                }

                &:hover, &:focus {
                    background-color: #fff;
                    border: 1px solid #108EE9;

                }
            }
            /deep/ .el-icon-date:before {
                    content: "\E78E";
                    display: none;
                }
                /deep/.el-input__icon{
                    // display: none;
                }
            }
        /deep/ .el-input {
            width: initial;
            margin-bottom: 22px;
            margin-right: 30px;
        }

        /deep/ .el-input__inner {
            width: 242px;
            height: 35px;
            min-height: 35px;
            font-size: 12px;
            color: #999999;
            background-color: #f2f4f7;
            border: 1px solid #f2f4f7;
            border-radius: 5px;

            &:hover,
            &:focus {
                background-color: #fff;
                border: 1px solid #108ee9;
            }
        }

        /deep/ .el-input__prefix {
            top: -3px;
        }

        /deep/ .el-input__suffix {
            top: 2px;
        }

        /deep/ .el-button {
            display: block;
            line-height: 35px;
            padding: 0;
            height: 35px;
        }

        .searchBtn {
            width: 82px;
            background: #3d7fff;
            border: none;
            border-radius: 15px;
            font-size: 14px;
            color: #ffffff;
            margin-bottom: 22px;
        }

        .resetBtn {
            color: #333333;
            margin-bottom: 22px;
        }
    }

    .orderListTable {
        .orderNomesaage {
            color: #888;
            text-align: center;
            padding: 15px 0;
        }
        .tableHeader {
            display: flex;
            width: 100%;
            height: 35px;
            line-height: 35px;
            background: #f3f7ff;
            border-radius: 5px;
            margin: 0 0 15px;

            li {
                text-align: center;
                font-size: 14px;
                color: rgba(0, 0, 0, 0.85);
            }
        }

        .tableBody {
            li {
                width: 100%;
                border: 1px solid #f2f2f2;
                border-radius: 10px;
                margin-bottom: 16px;

                .itemTop {
                    width: 100%;
                    height: 42px;
                    background: #ebf3fb;
                    line-height: 42px;
                    font-size: 14px;
                    color: #333;
                    padding: 0 20px;
                    display: flex;
                    align-items: center;
                    position: relative;

                    div {
                        margin-right: 30px;
                    }

                    .merchantInfo {
                        display: flex;
                        align-items: center;

                        i {
                            color: #3d7fff;
                            font-size: 25px;
                            cursor: pointer;
                            padding-left: 5px;
                            display: block;
                        }

                        img {
                            display: block;
                            margin-right: 5px;
                            width: 30px;
                            height: 30px;
                            border-radius: 50%;
                        }
                    }

                    .complainBtn {
                        color: #999;
                        position: absolute;
                        right: 20px;
                    }
                }

                .itemBottom {
                    display: flex;
                    align-items: center;
                    color: #333;
                    font-size: 13px;

                    .orderInfo {
                        padding: 20px;
                        display: flex;
                        align-items: center;
                        border-right: 1px solid #efefef;
                        justify-content: center;

                        .orderInfoImg {
                            margin-right: 30px;
                            text-align: center;

                            button {
                                width: 100%;
                                margin-top: 7px;
                                background: #fff;
                                color: #0c75d3;
                                border: 1px solid #0c75d3;
                                border-radius: 4px;
                            }
                        }

                        img {
                            display: block;
                            width: 100px;
                            height: 100px;
                            border-radius: 10px;
                        }

                        .infoContent {
                            .infoName {
                                font-size: 14px;
                                color: #000000;
                                padding-bottom: 10px;
                            }

                            .infoOther {
                                font-size: 13px;
                                color: #999999;
                                padding-bottom: 8px;
                            }
                        }
                    }

                    .arguments {
                        padding: 20px;
                    }

                    .argumentsName {
                        padding-bottom: 8px;
                    }

                    .payment {
                        h3 {
                            font-size: 14px;
                            font-weight: 700;
                            margin: 0;
                        }

                        .title {
                            font-size: 12px;
                            color: #999999;
                        }
                    }

                    .status {
                        font-size: 14px;
                    }

                    .operationBtn {
                        display: block;
                        color: #0c75d3;
                        text-align: center;
                        width: 100%;
                        margin: 0;
                    }

                    .operationBtnMoney {
                        color: #0c75d3;
                        padding: 6px 20px;
                        border: 1px solid #0c75d3;
                        border-radius: 6px;
                        margin-left: 10px;
                        margin-top: 12px;
                        &:nth-last-of-type(1) {
                            margin-bottom: 12px;
                        }
                    }
                }
            }
        }

        .name {
            flex: 1;
        }

        .price {
            width: 13%;
            text-align: center;
            margin: 0 20px;
            display: -webkit-box;
            overflow: hidden;
            white-space: normal !important;
            text-overflow: ellipsis;
            word-wrap: break-word;
            -webkit-line-clamp: 4;
            -webkit-box-orient: vertical
        }

        .num {
            width: 13%;
            text-align: center;
        }

        .arguments {
            width: 10%;
        }

        .payment {
            width: 14%;
            text-align: center;
        }

        .status {
            width: 10%;
            text-align: center;
        }

        .operation {
            width: 10%;
            text-align: center;
        }
    }

    .pagination {
        margin-top: 20px;
        text-align: right;
    }
}

.evaluateDialogBox {
    .evaluateItem {
        .name {
            font-size: 14px;
            color: #000;
            padding-bottom: 20px;
            font-weight: bold;
        }

        .content {
            padding-left: 20px;
            padding-bottom: 15px;
        }

        .rateItem {
            display: flex;
            align-items: center;
            padding-bottom: 15px;

            .name {
                padding: 0 20px 0 0;
                font-size: 13px;
                color: #333;
                min-width: 100px;
                font-weight: normal;
            }
        }

        .evaluateTag {
            display: flex;
            flex-wrap: wrap;

            /deep/ .el-checkbox-button {
                display: block;
                margin-right: 20px;
                margin-bottom: 15px;
            }

            /deep/ .el-checkbox-button__inner {
                border: 1px solid #dcdfe6 !important;
                border-radius: 4px;
                padding: 8px 15px;
                font-size: 13px;
                box-shadow: none;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/transaction/orderManagement/modelOrderList.vue